export default {
  EMAIL: "Invalid email format.",
  PASSWORD: "Your password must contain a number and at least 8 characters.",
  NOT_EMPTY: "Must not be empty.",
  LETTERS_ONLY: "Must only use letters.",
  NUMBERS_ONLY: "Must only use numbers.",
  WORDS: "Must only use letters.",
  POSTAL: "Invalid postal code.",
  ADULT_ONLY: "You must be 18 years old or older.",
  CREDIT_CARD: "Must only use numbers and be at least 13 digits.",
  CVV: "Must only use numbers and be at least 3 digits.",
  NO_VALIDATION: "",
  LENGTH_GREATER_THAN: "Your password must be at least 6 characters long."
};